{
  "boostAvios": {
    "title": "Boost your Avios",
    "body": "Multiply the Avios you collected <b>last month by up to 4x</b>. Pay less per Avios than when buying them directly. You can boost once a month. <a href=\"/fi-en/finnair-plus/buy--transfer-or-exchange-avios/boost-your-avios\">Learn more about boosting Avios.</a>",
    "boostNow": "Boost Avios now",
    "eligibleHeading": "Avios you can boost this month",
    "aviosLabel": "Avios",
    "mfaRequired": {
      "title": "Two-factor authentication is required",
      "text": "To buy or transfer Avios, you need to enable two-factor authentication.",
      "enableNow": "Enable now"
    },
    "mfaEnabled": {
      "title": "Two-factor authentication enabled",
      "text": "You can go back and boost your Avios.",
      "manageAvios": "Manage Avios"
    },
    "eligibleTransactions": {
      "transactionsHeading": "Eligible transactions*",
      "aviosHeading": "Avios",
      "total": "Total eligible Avios from last month:",
      "footnote": "*Includes flown flights and transactions made with our partners, including hotels and car rentals.",
      "footnoteFinland": "*Includes flown flights and transactions made with our partners, including hotels, car rentals and Finnair Visa credit cards.",
      "loading": "Loading transactions",
      "loadError": "We couldn’t load your transactions. Reload the page to try again."
    },
    "aviosPending": {
      "title": "Don’t see all the Avios you collected last month?",
      "text": "Our FAQ explains the most common reasons.",
      "readFaq": "Read the FAQ",
      "faqLink": {
        "url": "/fi-en/frequently-asked-questions/finnair-plus/my-avios-from-last-month-aren-t-showing---why--4484334"
      }
    },
    "boostCompleted": {
      "title": "{amount} Avios added",
      "text": "Your new Avios balance is {to}."
    },
    "boostUnconfirmed": {
      "title": "Your boost isn’t confirmed yet",
      "text": "Check your balance again later. You’ll get an email when the boost is confirmed or if the payment didn’t go through."
    },
    "ineligible": {
      "alreadyBoosted": "You’ve already boosted your Avios this month. Keep collecting and come back next month.",
      "belowMinimum": "Not enough Avios from last month to boost. You need at least {minimum} Avios."
    },
    "promo": {
      "text": "New: boost the Avios you collected last month and reach your rewards faster.",
      "link": "Manage Avios"
    }
  },
  "navigation": {
    "newBadge": "New"
  }
}
